import { useSelector } from 'react-redux';
import { getDatePattern, getTimePattern } from 'store/slices/userSettingsSlice';

import { formatDate, formatTime } from '../../helper/time';

interface DateTimeProps {
    date: Date;
    className?: string;
    separator?: boolean;
}

const DateTime = ({ date, className, separator }: DateTimeProps) => {
    const datePattern = useSelector(getDatePattern);
    const timePattern = useSelector(getTimePattern);

    return (
        <span data-testid='datetime-component' className={`display-flex align-items-center gap-5 ${className}`}>
            <span data-testid='datetime-component-time' className={separator ? '' : 'w-40'}>
                {formatTime(date, timePattern)}
            </span>
            {separator && <span data-testid='datetime-component-separator'>-</span>}
            <span data-testid='datetime-component-date' className={separator ? '' : 'w-90px'}>
                {formatDate(date, datePattern)}
            </span>
        </span>
    );
};

export default DateTime;
